

































import { Prop, Vue, Component, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() originColor!: string;
  dialogVisible: boolean = false;
  colorList: string[] = [
    "#FF9140",
    "#FFB940",
    "#A3CC13",
    "#67C632",
    "#07D1AA",
    "#32BDF3",
    "#48A1F7",
    "#48A1F7",
    "#CF75DC",
    "#F56C6C",
    "#FFAD71",
    "#FDC86D",
    "#B5D059",
    "#89E257",
    "#6EDBC6",
    "#6ECDF1",
    "#88BFF5",
    "#B4BFFC",
    "#E3ACEB",
    "#F79696",
    "#E0A478",
    "#D8B578",
    "#A1B267",
    "#8FC471",
    "#7EBCB0",
    "#81C1D9",
    "#95B5D5",
    "#B7BEE1",
    "#BF97C5",
    "#D38989",
  ];
  current: string = "";
  showDialog() {
    this.dialogVisible = true;
  }
  hideDialog() {
    this.dialogVisible = false;
  }
  handleChange(v: string) {
    this.current = v;
    this.dialogVisible = false;
    this.$emit("update:originColor", v);
  }
  @Watch("originColor", { immediate: false, deep: false })
  onOriginChange(n: string) {
    if (n) {
      this.current = n;
    }
  }
}
